import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AdmitStatusService from "../../src/Services/AdmitStatus.service";
import LookupGeneric from "./lookupGeneric";
const AdmitStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            return AdmitStatusService.findByIds(ids);
        },
        fetchOptions: (query) => {
            return AdmitStatusService.search({
                query,
                active: true, // if AdmitStatus has an active field for this purpose
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(admitStatus) {
            return _jsx("span", { children: admitStatus.name });
        },
    });
};
export default AdmitStatusLookup;
